export const SITE = {
  name: "FindlayChryslers.com",
  baseUrl: "https://www.findlaychryslers.com",
  defaultOgImage: "https://www.findlaychryslers.com/og.jpg",
};

